import { useAppUser, useWeldOwner } from '@bechtel/client-common';
import { AuthPermission, AuthScope, CommodityAssignee } from '@bechtel/types';
import { useMemo } from 'react';

export function useWeldPermissions(assignedCrewMembers?: CommodityAssignee[]) {
  const { hasPermissionScope } = useAppUser();
  const isOwner = useWeldOwner(assignedCrewMembers);
  const weldPermissions = useMemo(() => {
    const hasWeldPermissionScope = (permission: AuthPermission) =>
      (isOwner && hasPermissionScope({ permission: permission, scope: AuthScope.MY_COMMODITIES })) ||
      hasPermissionScope({ permission: permission, scope: AuthScope.ALL_COMMODITIES });

    return {
      canUploadDocument: hasWeldPermissionScope(AuthPermission.COMMODITY_DOCUMENT_UPLOAD),
      canUploadPhotos: hasWeldPermissionScope(AuthPermission.ADD_ATTACHMENT_WELD),
      canAssignFieldWeldEngineer: hasWeldPermissionScope(AuthPermission.ASSIGN_FIELD_WELD_ENGINEER),
      canAssignWeldForeman: hasWeldPermissionScope(AuthPermission.ASSIGN_WELD_FOREMAN),
      canReassignWeldForeman: hasWeldPermissionScope(AuthPermission.REASSIGN_WELD_FOREMAN),
      canAssignWeldPriority: hasWeldPermissionScope(AuthPermission.ASSIGN_UNASSIGN_PRIORITY_WELD),
      canClaimWeld: hasWeldPermissionScope(AuthPermission.CLAIM_UNCLAIM_WELD),
      canRejectWeld: hasWeldPermissionScope(AuthPermission.REJECT_WELD),
      canApproveWeld: hasWeldPermissionScope(AuthPermission.APPROVE_UNAPPROVE_WELD),
      canRejectFitup: hasWeldPermissionScope(AuthPermission.REJECT_FITUP),
      canApproveFitup: hasWeldPermissionScope(AuthPermission.APPROVE_UNAPPROVE_FITUP),
      canDeleteCommodityAttachment: hasWeldPermissionScope(AuthPermission.DELETE_COMMODITY_DOCUMENT),
      canDeleteWeldAttachment: hasWeldPermissionScope(AuthPermission.DELETE_ATTACHMENT_WELD)
    };
  }, [hasPermissionScope, isOwner]);

  return weldPermissions;
}
